import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTableBase from "../../common/Datatable";
import InputSearch from "../../common/InputSearch";
import makeRequest from "../../../../api";
import { trainerService } from "../../../../api/services";
import { toast } from "react-toastify";

const TrainersListingPage = () => {
  const [trainers, setTrainers] = useState<any>([]);
  const [searchedTerm, setSearchedTerm] = useState("");
  const filteredList = trainers?.filter((item: any) =>
    item?.name?.toLowerCase()?.includes(searchedTerm?.toLowerCase())
  );

  useEffect(() => {
    fetchTrainers();
  }, []);

  const fetchTrainers = async () => {
    try {
      const res = await makeRequest(trainerService.getAllTrainersList());
      setTrainers([...res?.data?.trainers]);
    } catch (error: any) {
      toast.error("Error fetching trainers list!");
    }
  };

  const columns = [
    {
      name: "Trainer Name",
      selector: (row: any) => row.name,
      cell: (row: any) => {
        return <div>{row.name}</div>;
      },
      sortable: true,
    },
    {
      name: "Trainer Category",
      selector: (row: any) => row.category,
      cell: (row: any) => {
        return (
          <div className="text-capitalize">
            {row?.category?.toLowerCase()?.replaceAll("_", " ")}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Roles",
      selector: (row: any) => row.roles,
      cell: (row: any) => {
        return (
          <div>
            {row?.roles?.map((item: any) => item?.roleName)?.join(", ")}
          </div>
        );
      },
    },
    {
      name: "Actions",
      selector: (row: any) => row.roles,
      cell: (row: any) => {
        return (
          <>
            <Link
              to={`${row.trainerId}`}
              className="btn btn-outline-primary btn-sm me-3"
            >
              Edit Roles
            </Link>
            <Link
              to={`/trainers/slots?trainerId=${row.trainerId}`}
              className="btn btn-outline-dark btn-sm me-3"
            >
              Availability
            </Link>
            <Link
              to={`/trainers/sessions?trainerId=${row.trainerId}`}
              className="btn btn-outline-dark btn-sm"
            >
              Sessions
            </Link>
          </>
        );
      },
      width: "40%",
    },
  ];

  return (
    <div className="container-lg">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Trainer List
            </li>
          </ol>
        </nav>
        <InputSearch
          value={searchedTerm}
          setValue={setSearchedTerm}
          placeholder="Search trainer"
        />
      </div>
      <DataTableBase columns={columns} data={filteredList} />
    </div>
  );
};

export default TrainersListingPage;
